import { Grid, Table, TableBody, TableContainer } from '@mui/material';
import { useState } from 'react';
import AppContainer from 'src/components/appComponents/AppContainer';
import AppTableToolbar from 'src/components/appComponents/table/AppTableToolbar';
import Scrollbar from 'src/components/scrollbar';
import {
  TableHeadCustom,
  TablePaginationCustom,
  TableSkeleton,
  useTable,
} from 'src/components/table';
import { useGetAllInstallReferrerQuery } from 'src/graphql';
import { paths } from 'src/routes/paths';
import InstallReferrerTableRow from 'src/sections/installReferrers/installReferrerTableRow';
import { Install_Referrer_TABLE_HEAD } from 'src/utils/tables-headers';

export default function InstallReferrerPage() {
  const table = useTable();
  const [search, setSearch] = useState({ subject: '', status: '' });

  const { data, isLoading } = useGetAllInstallReferrerQuery({
    offset: table.offset,
    limit: table.rowsPerPage,
  });

  return (
    <AppContainer
      pageTitle="InstallReferrer"
      routeLinks={[{ name: 'Help Center' }, { name: 'InstallReferrer' }]}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <AppTableToolbar
            tableName="InstallReferrer"
            path={paths.dashboard.helpCenter.csvFileTracker}
            permissionName={undefined}
            setSearch={setSearch}
          />
        </Grid>
        <Grid item xs={12}>
          <TableContainer>
            <Scrollbar>
              <Table>
                <TableHeadCustom headLabel={Install_Referrer_TABLE_HEAD} />
                <TableBody>
                  {isLoading
                    ? [...Array(table.rowsPerPage)].map((i, index) => (
                        <TableSkeleton key={index} sx={{ height: 80 }} />
                      ))
                    : data?.install_referrers?.map((row: any) => (
                        <InstallReferrerTableRow key={row.id} row={row as any} />
                      ))}
                </TableBody>
              </Table>
            </Scrollbar>
          </TableContainer>
          {data && (
            <TablePaginationCustom
              count={data?.install_referrers_aggregate?.aggregate?.count ?? 0}
              page={table.page}
              rowsPerPage={table.rowsPerPage}
              onPageChange={table.onChangePage}
              onRowsPerPageChange={table.onChangeRowsPerPage}
            />
          )}
        </Grid>
      </Grid>
    </AppContainer>
  );
}
